import { identifierModuleUrl } from '@angular/compiler';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { WebRequestService } from 'src/app/services/web-request.service';
import { LoaderComponent } from '../../components/builders/loader/loader.component';
import { Data } from 'src/app/helper/datastore';

@Component({
  selector: 'app-ticketcreation',
  templateUrl: './ticketcreation.component.html',
  styleUrls: ['./ticketcreation.component.scss']
})
export class TicketcreationComponent implements OnInit {

  @ViewChild('alertModal')
  alertModal: any;
  @Input() isOtherSideSecession: any;
  @Input() data: any;
  @Input() selectedTab: any;
  @Input() isDisplayInterested: any
  @Input() type: any;
  @Input() tabValue: any;
  @Output()
  ticketScreen = new EventEmitter();
  ticketForm: FormGroup
  _profileOwner: any = []
  selectedType: any
  isAccessObj:any;
  isCallDiscussion: any = false;
  isCallDiscussionDisabled: any = false;
  isCallDescription: any = true;
  isDisplayToCustomer: any = false;
  LoaderComponent: any;
  callTypeValue: any;
  reasonForm: FormGroup;
  callReasonArray:any = [];
  @ViewChild('successModal')
  successModal: any;
  @ViewChild('reasonModal')
  reasonModal:any;
  contactRelationArray:any;
  dropdownSettings: any = {
    singleSelection: true,
    idField: 'value',
    textField: 'label',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };
  reasonDropdownSettings: any = {
    singleSelection: true,
    idField: 'id',
    textField: 'value',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };
  isDataIncoming: any = "";
  isView: any;
  relationArray = [
    { "label": "Father", "title": "Father", "value": 39 },
    { "label": "Mother", "title": "Mother", "value": 40 },
    { "label": "YoungerBrother", "title": "YoungerBrother", "value": 41 },
    { "label": "ElderBrother", "title": "ElderBrother", "value": 42 },
    { "label": "Self", "title": "Self", "value": 283 },
    { "label": "YoungerSister", "title": "YoungerSister", "value": 321 },
    { "label": "ElderSister", "title": "ElderSister", "value": 322 },
    { "label": "FatherYoungerBrother", "title": "FatherYoungerBrother", "value": 323 },
    { "label": "FatherElderBrother", "title": "FatherElderBrother", "value": 324 },
    { "label": "FatherYoungerSister", "title": "FatherYoungerSister", "value": 325 },
    { "label": "FatherElderSister", "title": "FatherElderSister", "value": 326 },
    { "label": "MotherYoungerBrother", "title": "MotherYoungerBrother", "value": 327 },
    { "label": "MotherElderBrother", "title": "MotherElderBrother", "value": 328 },
    { "label": "MotherYoungerSister", "title": "MotherYoungerSister", "value": 329 },
    { "label": "MotherElderSister", "title": "MotherElderSister", "value": 320 },
    { "label": "Spouse", "title": "Spouse", "value": 334 },
    { "label": "XRelation", "title": "XRelation", "value": 554 },
    { "label": "GrandFather", "title": "GrandFather", "value": 556 },
    { "label": "GrandMother", "title": "GrandMother", "value": 557 },
    { "label": "SisterHusband", "title": "SisterHusband", "value": 558 },
    { "label": "Friend", "title": "Friend", "value": 559 },
    { "label": "Relative", "title": "Relative", "value": 560 },
    { "label": "Uncle", "title": "Uncle", "value": 561 },
    { "label": "Aunt", "title": "Aunt", "value": 562 }
  ];
  voiceCallsType: any = [
    { "label": "Whatsapp call", "title": "Whatsapp call", "value": 589 },
    { "label": "Mobile call", "title": "Mobile call", "value": 590 },
    { "label": "Land call", "title": "Land call", "value": 591 },
    { "label": "Magic Jack", "title": "Magic Jack", "value": 592 },
    { "label": "Whatsapp Message", "title": "Whatsapp Message", "value": 593 },
    { "label": "Mobile Message", "title": "Mobile Message", "value": 594 }
  ];
  basicInfo = ""
  ticketStatus: any;
  relationShipData: any;
  responseHistory: any;
  ticketHistory: any
  isTicketSubmitted: boolean = false;
  empId: any;
  alertMessage: any;
  selectedRadioBtn: any;
  loginData: any
  isDisableTabs: boolean = false;
  TicketReasonArray: any[]=[];
  isReason:boolean = false;
  isReasonID: any;
  tracking:boolean;
  showMobileOrEmail: boolean = false;
  viewContactOrEmailObj:any;
  responseMessage: any;
  numberAfterReason:any;
  cancdidateContactDetails: any;
  noAccess: boolean;
  constructor(public service: WebRequestService, private loginDataStore: Data) {
    this.ticketForm = new FormGroup({
      callRecv: new FormControl("", [Validators.required]),
      relationName: new FormControl("", [Validators.required]),
      telNo: new FormControl(""),
      callResult: new FormControl("", [Validators.required]),
      voiceCallType: new FormControl("", [Validators.required]),
      rType: new FormControl("", [Validators.required]),
      callDiscussion: new FormControl("", [Validators.required]),
      notes: new FormControl(""),
      displayToCustomer: new FormControl("0"),
      reason: new FormControl('')
    })
    this.ticketForm.get('rType').valueChanges.subscribe(val => {
      if (this.isReasonID == 4) {
        this.ticketForm.controls['reason'].setValidators([Validators.required]);
        if(this.ticketForm.controls['notes']) {
        this.ticketForm.controls['notes'].clearValidators();
        this.ticketForm.controls['notes'].updateValueAndValidity();
        }
      } 
      else if(this.isReasonID == 3) {
        this.ticketForm.controls['reason'].clearValidators();
        if(this.ticketForm.controls['notes']) {
        this.ticketForm.controls['notes'].clearValidators();
        this.ticketForm.controls['notes'].updateValueAndValidity();
        }
      }
      else {
        this.ticketForm.controls['reason'].clearValidators();
        this.ticketForm.controls['notes'].setValidators([Validators.required]);
      }
      this.ticketForm.controls['reason'].updateValueAndValidity();
      this.ticketForm.controls['notes'].updateValueAndValidity();
    });
  }
  isReasonFlag(event){ 

    this.isReasonID = event.target.value
      
  }
  changeTab(data) {
    this.ticketForm.reset();
    this.ticketForm.patchValue({
      displayToCustomer: "0"
    })
    this.callTypeValue = data;

    this.isTicketSubmitted = false;
    this.loadBasicData();
    this.isCallDiscussion = false;
    switch (data) {
      case 1:
        this.isDataIncoming = '';
        this.isDataIncoming = 'Incoming';
        this.selectedType = 5;
        this.ticketForm.patchValue({
          callDiscussion: ""
        })
        break;
      case 2:
        this.isDataIncoming = '';
        this.isDataIncoming = 'outGoing';
        this.selectedType = 6;
        this.ticketForm.patchValue({
          callDiscussion: ""
        })
        this.loadBasicData()
        break;
      case 0:
        this.isView = true;
        this.isDataIncoming = '';
        this.isDataIncoming = 'view';
        this.loadBasicData();
        break;
    }
  }
  ngOnInit(): void {
    this.selectedType = 6;
    if (this.type === 'communication') {
      this.isView = true;
      this.isDataIncoming = 'view';
    } else {
      this.isDataIncoming = 'outGoing';
      this.callTypeValue = 2;

    }
    if (this.data.history && this.data.history.TicketStatusID === 258) {
      this.isDisableTabs = true
    }else {
      this.isDisableTabs = false
    }
    this.loadBasicData();

    this.service.loadMasterDataWithId('TicketReason', this.data['ticketId']).then((res) => {
      if (res['statusCode'] === 200) {
        let ticketReason = res['result'].filter((arr)=>{
         return arr.value != null
        })
        this.TicketReasonArray = ticketReason;
        console.log(this.TicketReasonArray)


      }      
    }).catch((err) => { console.log(err) })
    this.reasonForm = new FormGroup({
      reason: new FormControl(null, [Validators.required])
    })

    this.service.loadMasterData('ClickToCallReason').then((res) => {
      if (res['statusCode'] === 200) {
        this.callReasonArray = res['result'];

      }      
    }).catch((err) => { console.log(err) })

    // console.log('custid',this.data['custId'])

    this.service.loadMasterDataWithId('contactRelation',String(this.data['custId'])).then((res) => {
      if(res['statusCode'] === 200){
        this.contactRelationArray = res['result'];
        // console.log(this.contactRelationArray)
      }})
  }
  loadBasicData() {
    console.log(this.type);
    this.loginDataStore.getStoreData('empData')
      .then((dataRes: any) => {
        this.loginData = JSON.parse(dataRes);
      })
      .catch((err) => console.error(err)); this.service.matchFollowUpTicketStatus(this.data['ticketId']).then((response) => {
        this.LoaderComponent = LoaderComponent
        if (response['statusCode'] === 200) {
          this.LoaderComponent = "";
          this.ticketForm.patchValue({
            callRecv: [{ "label": "Father", "title": "Father", "value": 39 }],
          })
        }
      })
    this.service.getRelationData(3, this.data['profileId'], 39).then((relationResponse) => {
      this.LoaderComponent = LoaderComponent;
      if (relationResponse['statusCode'] === 200) {

        this.LoaderComponent = "";
        this.relationShipData = relationResponse['result'][0][0]['NAME']
        this.ticketForm.patchValue({
          callRecv: [{ "label": "Father", "title": "Father", "value": 39 }],
          relationName: this.relationShipData
        })
      } else {
        this.LoaderComponent = "";
        this.noAccess = true;

      }

    })
  if(this.data != undefined) {
   if(this.data?.history?.FromOwnerID == this.loginData?.employeeID || this.loginData?.isManagement == 1) {
    this.ticketForm.controls['telNo'].setValue(this.data['phoneNumber']);
   }
  }
    if (this.type === undefined) {
      if (this.data['ticketId'] != null) {
        console.log(this.data['ticketId'])
        this.service.getMatchTicketHistory(this.data['ticketId'], 'I').then((response) => {
          this.LoaderComponent = LoaderComponent;

          if (response['statusCode'] === 200) {
            this.LoaderComponent = "";

            this.responseHistory = response['result'][0];
          } else {
            this.LoaderComponent = "";

          }
        })
      }

    } else {
      this.responseHistory = this.data['history'];
    }

    if (this.data['ticketId'] != null) {
      this.LoaderComponent = LoaderComponent;
      this.service.getMatchTicketHistory(this.data['ticketId'], 'H').then((response) => {
        if (response['statusCode'] === 200) {
          this.LoaderComponent = "";
          this.ticketHistory = response['result'];
        } else {
          this.LoaderComponent = "";

        }
      })
    }

  }
  submitContact() {

  }
  openMatchFollowTicket(ticketId){
    let data ={
      "empID": sessionStorage.getItem('empId'),
      "ticketID": ticketId,
    }
    this.LoaderComponent = LoaderComponent;
    this.service.openMatchFollowTicket(data).then(response =>{
      if (response['statusCode'] === 200) {
        this.LoaderComponent = ""
        this.isDisableTabs = false
        let communicationObj = {
          CallDiscussion: "Ticket Opened By " + this.loginData['firstName'],
          CallType: 379,
          EmpID: this.loginData['employeeID'],
          TicketID: ticketId,
        }
        this.service.callCommunicationLog(communicationObj).then((resp) => {
          if (resp['statusCode'] === 200) {
            this.LoaderComponent = "";
            this.alertMessage = "Ticket Opened Successfully";
            this.alertModal.show();
            setTimeout(() => {
              this.alertModal.hide();
            }, 5000);
          }
        })
      }else{
        this.LoaderComponent = ""
      }
    })
  }
  ngOnChanges() {
  }

  callResult(data) {
    switch (data) {
      case 1: break;
      case 0: break;
      case 2: break;
    }
  }
  replyType(data) {
    this.selectedRadioBtn = data;
    let value = "";
    let newValue = ""
    switch (data) {

      case 1:
        this.isCallDiscussion = true;
        // this.ticketForm.setValidators({disabled:true})
        this.isCallDiscussionDisabled = true;
        this.isCallDescription = true;
        this.isReason = false;
        this.isDisplayToCustomer = true;
        this.selectedType = 1
        value = this.getSelectedBtnText(this.tabValue, this.responseHistory, data)
        newValue = this.getNewSelectedBtnText(data, this.responseHistory)
        this.ticketForm.patchValue({
          callDiscussion: value ? value : newValue
        })
        break;
      case 2:
        this.isCallDiscussion = true;
        this.isCallDiscussionDisabled = true;
        this.isCallDescription = true;
        this.isReason = false;
        this.isDisplayToCustomer = true;
        this.selectedType = 2;
        value = this.getSelectedBtnText(this.tabValue, this.responseHistory, data)
        newValue = this.getNewSelectedBtnText(data, this.responseHistory)
        this.ticketForm.patchValue({
          callDiscussion: value ? value : newValue
        })
        break;
      case 3:
        this.isCallDiscussion = true;
        this.isCallDiscussionDisabled = false;
        this.isReason = false;
        this.isCallDescription = false;
        this.isDisplayToCustomer = false
        this.selectedType = 3;
        value = this.getSelectedBtnText(this.tabValue, this.responseHistory, data)
        newValue = this.getNewSelectedBtnText(data, this.responseHistory)
        this.ticketForm.patchValue({
          callDiscussion: value ? value : newValue
        })
        break;
      case 4:

        this.isCallDiscussion = true;
        this.isReason = true;
        this.isCallDiscussionDisabled = false;
        this.isCallDescription = false;
        this.isDisplayToCustomer = true;
        this.selectedType = 4;
        this.ticketForm.patchValue({
          callDiscussion: ""
        })
        break;
    }
  }

  getSelectedBtnText(type, dataObj, radioValue) {
    let text = ""
    if (type === 'BSI' || type === 'PFM') {
      if (radioValue === 2) {
        text = "";
        return text = `We informed to ${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} about your interest to proceed  but   ${dataObj['GenderID'] === 2 ? 'She' : 'He'} is not keen to proceed ahead. For further communication please contact your relationship manager.`
      } else if (radioValue === 1) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} is also interested in your profile, Since both of you are interested you need one of our customer relationship manager assistance.`
      } else if (radioValue === 3) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} viewed your full profile and is seeking Three more days to update ${dataObj['GenderID'] === 2 ? 'She' : 'He'}  opinion. Meanwhile lets look into other options.`
      } else if (radioValue === 4) {
        text = "";
        return text = ``
      }

    } else if (type === 'MMS') {
      if (radioValue === 2) {
        text = "";
        return text = `We informed to ${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} about your interest to proceed  but   ${dataObj['GenderID'] === 2 ? 'She' : 'He'} is not keen to proceed ahead. For further communication please contact your relationship manager.`
      } else if (radioValue === 1) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} is also interested in your profile, Since both of you are interested you need one of our customer relationship manager assistance.`
      } else if (radioValue === 3) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} viewed your full profile and is seeking Three more days to update  ${dataObj['GenderID'] === 2 ? 'her' : 'his'}  opinion. Meanwhile lets look into other options.`
      } else if (radioValue === 4) {
        text = "";
        return text = ``
      }
    } else if (type === 'OSI') {
      if (radioValue === 2) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} viewed your  profile and did not respond positive.Lets proceed further with our new search options.`
      } else if (radioValue === 1) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} is also interested in your profile, Since both of you are interested you need one of our customer relationship manager assistance.`
      } else if (radioValue === 3) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} viewed your full profile and is seeking Three more days to update  ${dataObj['GenderID'] === 2 ? 'her' : 'his'}  opinion. Meanwhile lets look into other options.`
      } else if (radioValue === 4) {
        text = "";
        return text = ``
      }
    } else if (type === 'OSCT') {
      if (radioValue === 2) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} Viewed your Profile but you were not keen to proceed ahead. Incase if you want to rethink about this profile please contact your relationship manager.`
      } else if (radioValue === 1) {
        text = "";
        return text = `We are Resending the profile of ${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} (${dataObj['FromProfileID']})  now for your Reference which was already sent to you on ${dataObj['ticketCreatedDate'].trim()}. Please go through the details and contact your relationship manager for further information.`

      } else if (radioValue === 3) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} viewed your full profile and is seeking Three more days to update ${dataObj['GenderID'] === 2 ? 'her' : 'his'}  opinion. Meanwhile lets look into other options.`
      } else if (radioValue === 4) {
        text = "";
        return text = ``
      }
    } else if (type === 'MSI' || type === 'RI') {

      if (radioValue === 2) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} viewed your  profile and did not respond positive.Lets proceed further with our new search options.`
      } else if (radioValue === 1) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} (${dataObj['FromProfileID']}) profile was sent to you on ${dataObj['ticketCreatedDate'].trim()} and  ${dataObj['GenderID'] === 2 ? 'She' : 'He'} is showing interest in your profile Please go through the profile and reply to us on the same.We are resending her profile for the ease of viewing and please give your opinion in the options provided in the profile.`
      } else if (radioValue === 3) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} viewed your full profile and is seeking Three more days to update ${dataObj['GenderID'] === 2 ? 'her' : 'his'}  opinion. Meanwhile lets look into other options.`
      } else if (radioValue === 4) {
        text = "";
        return text = ``
      }
    } else if (type === 'SN') {
      if (radioValue === 2) {
        text = "";
        return text = `We have informed to ${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']}  about your interest to proceed  but  ${dataObj['GenderID'] === 2 ? 'She' : 'He'} is not keen to proceed ahead. For further communication please contact your relationship manager.`
      } else if (radioValue === 1) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} (${dataObj['FromProfileID']}) profile was sent to you on ${dataObj['ticketCreatedDate'].trim()} and  ${dataObj['GenderID'] === 2 ? 'She' : 'He'} is showing interest in your profile Please go through the profile and reply to us on the same.We are resending her profile for the ease of viewing and please give your opinion in the options provided in the profile.`
      } else if (radioValue === 3) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} viewed your full profile and is seeking Three more days to update ${dataObj['GenderID'] === 2 ? 'her' : 'his'}  opinion. Meanwhile lets look into other options.`
      } else if (radioValue === 4) {
        text = "";
        return text = ``
      }
    } else if (type === 'MSCT') {
      if (radioValue === 3) {
        text = "";
        return text = `${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} viewed your full profile and is seeking Three more days to update ${dataObj['GenderID'] === 2 ? 'her' : 'his'}  opinion. Meanwhile lets look into other options.`
      }
    }

  }
  getNewSelectedBtnText(radioValue, dataObj){
    let text = ''
    if (radioValue == 1) {
      return text = `We are Resending the profile of ${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} (${dataObj['FromProfileID']}) now for your Reference which was already sent to you on ${dataObj['ticketCreatedDate']}. Please go through the details and contact your relationship manager for further information.`
    }else if(radioValue == 2){
      return text =`${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} viewed your  profile and did not respond positive.Lets proceed further with our new search options`
    }else if(radioValue == 3){
      return text =`${dataObj['GenderID'] === 2 ? 'Ms.' : 'Mr.'} ${dataObj['CustomerLastName']} viewed your full profile and is seeking Three more days to update her  opinion.Meanwhile lets look into other options.`
    }
  }

  displayToCustomer(data) {
    switch (data) {
      case 1: break;
      case 0: break;
    }
  }
  getType() {
    if (this.selectedType === 5) {
      return 'Incoming'
    } else if (this.selectedType === 6) {
      return 'Outgoing'

    } else if (this.selectedType === 1) {
      return 'Interested'

    } else if (this.selectedType === 2) {
      return 'Close'
    } else if (this.selectedType === 3) {
      return 'Pending'
    } else if (this.selectedType === 4) {
      return 'FollowUp'
    }

  }

  submitIncoming() {
    if (this.selectedType === 4 || this.selectedType === 3) {
      this.ticketForm.value['notes'] = this.ticketForm.value['callDiscussion']
    }
    if(this.ticketForm.invalid){
      return
    }
    if (this.isDisplayInterested === true && this.selectedType != 3 && this.selectedType != 4) {
      if (this.ticketForm.value['relationName'] === null || this.ticketForm.value['relationName'] === undefined || this.ticketForm.value['relationName'] === "" ||
        this.ticketForm.value['callRecv'] === "" || this.ticketForm.value['callRecv'] === null || this.ticketForm.value['callRecv'] === undefined || this.ticketForm.value['callRecv'].length == 0 ||
        this.ticketForm.value['voiceCallType'] === "" || this.ticketForm.value['voiceCallType'] === null || this.ticketForm.value['voiceCallType'] === undefined ||
        this.ticketForm.value['rType'] === "" || this.ticketForm.value['rType'] === null || this.ticketForm.value['rType'] === undefined ||
        this.ticketForm.value['callDiscussion'] === "" || this.ticketForm.value['callDiscussion'] === null || this.ticketForm.value['callDiscussion'] === undefined ||
        this.ticketForm.value['callResult'] === '' || this.ticketForm.value['callResult'] === null ||
        this.ticketForm.value['notes'] === undefined || this.ticketForm.value['notes'] === '' || this.ticketForm.value['notes'] === null) {
        this.isTicketSubmitted = true;
      } else {
        this.saveData();
      }
    } else {
      if (this.ticketForm.value['relationName'] === null || this.ticketForm.value['relationName'] === undefined || this.ticketForm.value['relationName'] === "" ||
        this.ticketForm.value['callRecv'] === "" || this.ticketForm.value['callRecv'] === null || this.ticketForm.value['callRecv'] === undefined || this.ticketForm.value['callRecv'].length == 0 ||
        this.ticketForm.value['voiceCallType'] === "" || this.ticketForm.value['voiceCallType'] === null || this.ticketForm.value['voiceCallType'] === undefined ||
        this.ticketForm.value['rType'] === "" || this.ticketForm.value['rType'] === null || this.ticketForm.value['rType'] === undefined ||
        this.ticketForm.value['callResult'] === '' || this.ticketForm.value['callResult'] === null) {
        this.isTicketSubmitted = true;
      } else {
        this.saveData();
      }
    }

  }
  noAccessPopup() {
    this.responseMessage = 'You don\'t have access. Please contact Naveena and Team';
    this.successModal.show();
  }

  makingCall(access,type, numberoremail,custID,RM1, data){ 
    if(access == 'A'){
      this.responseMessage =  type == 'Mobile' ? `Mobile Number: ${numberoremail != null ? numberoremail : "Not-Given"}` : type == 'Email' ? `Email : ${numberoremail != null ? numberoremail : "Not-Given"}` : '';
      this.successModal.show();
    } else {
      this.numberAfterReason =  type == 'Mobile' ? `Mobile Number: ${numberoremail != null ? numberoremail : "Not-Given"}` : type == 'Email' ? `Email : ${numberoremail != null ? numberoremail : "Not-Given"}` : '';    
      this.isAccessObj = {
        custID: custID,
        viewCount:1,
        pageType: 12
      }
      this.viewContactOrEmailObj = {
        custID: custID,
        pageName: 'Marketing-slideshow',
        profileOwnerID: RM1,
        section: 'Marketing-slideshow',
        viewType: 'View',
        ContactType: 614,
        IPAddress: this.loginData.ipAddress
      }
      this.reasonModal.show()
    }

  }

  reasonToView(event){
    this.viewContactOrEmailObj.reason  = this.reasonForm.value['reason'].value;
    this.service.viewOtherContactAccess(this.isAccessObj).then((res)=>{
      this.reasonModal.hide();
      if(res['statusCode'] === 200){
        console.log(res['result'])
        if (res['result'][0].IsContactVisibleAccess) {
          this.service.viewContactOrEmailForOtherEmp(this.viewContactOrEmailObj).then((response)=>{
            this.responseMessage = this.numberAfterReason;
            this.successModal.show()
          })
        } else {
          this.reasonModal.hide();
          this.responseMessage = res['result'][0].IsConfidentialProfile ? "You have reached maximum limit to view contacts. Please Contact Naveena and Team" : "You have reached maximum limit to view contacts. Please Contact Siva Prasad and Team";
          this.successModal.show();
        }
      } else {
        this.responseMessage = "Please Try Again Later"
        this.successModal.show()
      }
    })
    this.reasonForm.patchValue({
      reason: ''
    })
  }


  closeReasonDialog(){
    this.showMobileOrEmail = false;
    this.reasonModal.hide()  
    this.reasonForm.patchValue({
      reason: ''
    })  
  }

  saveData() {

    if (this.selectedType === 2 || this.selectedType === 1) {
      this.LoaderComponent = LoaderComponent;
      this.service.saveMatchFollowupIncoming(this.getIntrestedNotIntrestedObject()).then((response) => {
        if (response['statusCode'] === 200) {
          this.LoaderComponent = "";
          if (this.callTypeValue === 2) {
            this.service.callCommunicationLog(this.getCommunicationLog(0)).then((response) => {
              if (response['statusCode'] === 200) {
                this.LoaderComponent = ""

                this.service.callCommunicationLog(this.getCommunicationLog(1)).then((response) => {
                  if (response['statusCode'] === 200) {
                    this.LoaderComponent = ""
                    if (this.ticketForm.value['displayToCustomer'] === "1") {
                      this.service.sendEmailFromTicket(this.getSendEmailObject(this.selectedType)).then((response) => {
                        if (response['statusCode'] === 200) {
                          this.LoaderComponent = ""

                          this.alertMessage = response['message']
                          this.alertModal.show();
                          //this.data = "";
                          //this.ticketForm.reset();
                          //this.loadBasicData()
                          setTimeout(() => {
                            this.alertModal.hide();
                            this.ticketScreen.emit(false);
                          }, 3000);

                        } else {
                          this.LoaderComponent = ""

                          this.alertMessage = response['message']
                          this.alertModal.show();
                          //this.data = "";
                          // this.ticketForm.reset();
                          //this.loadBasicData()
                          setTimeout(() => {
                            this.alertModal.hide();
                            this.ticketScreen.emit(false);
                          }, 3000);


                        }
                      })
                    } else {
                      this.LoaderComponent = ""

                      this.alertMessage = response['message']
                      this.alertModal.show();
                      //this.data = "";
                      //this.ticketForm.reset();
                      // this.loadBasicData()
                      setTimeout(() => {
                        this.alertModal.hide();
                        this.ticketScreen.emit(false);
                      }, 3000);

                    }
                  }

                })
              } else {
                this.LoaderComponent = ""

                this.alertMessage = response['message']
                this.alertModal.show();
                //this.data = "";
                // this.ticketForm.reset();
                //this.loadBasicData()
                setTimeout(() => {
                  this.alertModal.hide();
                  this.ticketScreen.emit(false);
                }, 3000);

              }
            })
          } else {
            this.service.callCommunicationLog(this.getCommunicationLogOut(0)).then((response) => {
              if (response['statusCode'] === 200) {
                this.LoaderComponent = ""

                this.service.callCommunicationLog(this.getCommunicationLogOut(1)).then((response) => {
                  if (response['statusCode'] === 200) {
                    this.LoaderComponent = ""
                    this.service.sendEmailFromTicket(this.getSendEmailObject(this.selectedType)).then((response) => {
                      if (response['statusCode'] === 200) {
                        this.LoaderComponent = ""

                        this.alertMessage = response['message']
                        this.alertModal.show();
                        //this.data = "";
                        //this.ticketForm.reset();
                        //this.loadBasicData()
                        setTimeout(() => {
                          this.alertModal.hide();
                          this.ticketScreen.emit(false);
                        }, 3000);

                      } else {
                        this.LoaderComponent = ""

                        this.alertMessage = response['message']
                        this.alertModal.show();
                        //this.data = "";
                        // this.ticketForm.reset();
                        //this.loadBasicData()
                        setTimeout(() => {
                          this.alertModal.hide();
                          this.ticketScreen.emit(false);
                        }, 3000);


                      }
                    })
                  }

                })
              } else {
                this.LoaderComponent = ""

                this.alertMessage = response['message']
                this.alertModal.show();
                //this.data = "";
                // this.ticketForm.reset();
                //this.loadBasicData()
                setTimeout(() => {
                  this.alertModal.hide();
                  this.ticketScreen.emit(false);
                }, 3000);

              }
            })

          }
        } else {
          this.LoaderComponent = ""

          this.alertMessage = response['message']
          this.alertModal.show();
          //  this.data = "";
          // this.ticketForm.reset();
          //this.loadBasicData()
          setTimeout(() => {
            this.alertModal.hide();
            this.ticketScreen.emit(false);
          }, 3000);



        }

      })

    } else if (this.selectedType == 3) {
      this.LoaderComponent = LoaderComponent;
      if (this.callTypeValue === 2) {
        this.service.callCommunicationLog(this.getCommunicationLog(1)).then((response) => {
          this.LoaderComponent = ""

          if (response['statusCode'] === 200) {
            this.service.sendEmailFromTicket(this.getSendEmailObject(this.selectedType)).then((response) => {
              this.LoaderComponent = ""
              if (response['statusCode'] === 200) {
                this.alertMessage = response['message']
                this.alertModal.show();
                //this.data = "";
                //this.ticketForm.reset();
                //this.loadBasicData()
                setTimeout(() => {
                  this.alertModal.hide();
                  this.ticketScreen.emit(false);
                }, 3000);

              } else {
                this.LoaderComponent = ""

                this.alertMessage = response['message']
                this.alertModal.show();
                // this.data = "";
                //this.ticketForm.reset();
                // this.loadBasicData()
                setTimeout(() => {
                  this.alertModal.hide();
                  this.ticketScreen.emit(false);
                }, 3000);

              }
            })
          } else {
            this.LoaderComponent = ""

            this.alertMessage = response['message']
            this.alertModal.show();
            // this.data = "";
            //this.ticketForm.reset();
            //this.loadBasicData()
            setTimeout(() => {
              this.alertModal.hide();
              this.ticketScreen.emit(false);
            }, 3000);

          }
        })
      } else {
        this.service.callCommunicationLog(this.getCommunicationLogOut(1)).then((response) => {
          this.LoaderComponent = ""

          if (response['statusCode'] === 200) {
            this.service.sendEmailFromTicket(this.getSendEmailObject(this.selectedType)).then((response) => {
              this.LoaderComponent = ""
              if (response['statusCode'] === 200) {
                this.alertMessage = response['message']
                this.alertModal.show();
                //this.data = "";
                //this.ticketForm.reset();
                //this.loadBasicData()
                setTimeout(() => {
                  this.alertModal.hide();
                  this.ticketScreen.emit(false);
                }, 3000);

              } else {
                this.LoaderComponent = ""

                this.alertMessage = response['message']
                this.alertModal.show();
                // this.data = "";
                //this.ticketForm.reset();
                // this.loadBasicData()
                setTimeout(() => {
                  this.alertModal.hide();
                  this.ticketScreen.emit(false);
                }, 3000);

              }
            })
          } else {
            this.LoaderComponent = ""

            this.alertMessage = response['message']
            this.alertModal.show();
            // this.data = "";
            //this.ticketForm.reset();
            //this.loadBasicData()
            setTimeout(() => {
              this.alertModal.hide();
              this.ticketScreen.emit(false);
            }, 3000);

          }
        })
      }


    } else if (this.selectedType == 4) {
      if (this.callTypeValue === 2) {
        this.LoaderComponent = LoaderComponent;
        this.service.callCommunicationLog(this.getCommunicationLog(0)).then((response) => {
          if (response['statusCode'] === 200) {
            this.LoaderComponent = ""

            if (response['statusCode'] === 200) {
              this.alertMessage = response['message']
              this.alertModal.show();
              //this.data = "";
              // this.ticketForm.reset();
              //this.loadBasicData()
              setTimeout(() => {
                this.alertModal.hide();
                this.ticketScreen.emit(false);
              }, 3000);


            } else {
              this.LoaderComponent = ""

              this.alertMessage = response['message']
              this.alertModal.show();
              //this.data = "";
              // this.ticketForm.reset();
              //this.loadBasicData()
              setTimeout(() => {
                this.alertModal.hide();
                this.ticketScreen.emit(false);

              }, 3000);

            }
          } else {
            this.LoaderComponent = ""

            this.alertMessage = response['message']
            this.alertModal.show();
            //this.data = "";
            // this.ticketForm.reset();
            //this.loadBasicData()
            setTimeout(() => {
              this.alertModal.hide();
              this.ticketScreen.emit(false);
            }, 3000);

          }
        })

      } else {
        this.LoaderComponent = LoaderComponent;
        let valueObj = this.getCommunicationLogOut(0);
        valueObj['CallType'] = ""
        this.service.callCommunicationLog(this.getCommunicationLogOut(0)).then((response) => {
          if (response['statusCode'] === 200) {
            this.LoaderComponent = ""

            if (response['statusCode'] === 200) {
              this.alertMessage = response['message']
              this.alertModal.show();
              //this.data = "";
              // this.ticketForm.reset();
              //this.loadBasicData()
              setTimeout(() => {
                this.alertModal.hide();
                this.ticketScreen.emit(false);
              }, 3000);


            } else {
              this.LoaderComponent = ""

              this.alertMessage = response['message']
              this.alertModal.show();
              //this.data = "";
              // this.ticketForm.reset();
              //this.loadBasicData()
              setTimeout(() => {
                this.alertModal.hide();
                this.ticketScreen.emit(false);

              }, 3000);

            }
          } else {
            this.LoaderComponent = ""

            this.alertMessage = response['message']
            this.alertModal.show();
            //this.data = "";
            // this.ticketForm.reset();
            //this.loadBasicData()
            setTimeout(() => {
              this.alertModal.hide();
              this.ticketScreen.emit(false);
            }, 3000);

          }
        })
      }

    }


  }

  getSendEmailObject(type) {
    return {
      EMPID: this.loginData['employeeID'],
      FromCustID: this.responseHistory['TocustID'],
      FromProfileID: this.responseHistory['toProfileID'],
      HistoryUpdate: 2,
      LTicketID: this.responseHistory['FromTicketid'],
      Notes: this.ticketForm.value['notes'] ? this.ticketForm.value['notes'] : this.ticketForm.value['callDiscussion'],
      TicketStatusID: type === 0 ? 'bothSideinterest' : type === 1 ? 'Viewed' : type === 2 ? 'Notinterest' : 'Viewed',
      ToProfileID: this.responseHistory['FromProfileID'],
      TocustID: this.responseHistory['FromCustID'],
      profileid: this.data['profileId']
    }

  }

  selectedRelation(id) {
    if (id && id.length > 0) {
      this.ticketForm.patchValue({
        relationName: ''
      })
      this.LoaderComponent = LoaderComponent;
      this.service.getRelationData(3, this.data['profileId'], id[0]['value']).then((relationResponse) => {
        if (relationResponse['statusCode'] === 200) {
          this.LoaderComponent = "";
          if (relationResponse['result'].length > 0 && relationResponse['result'][0].length > 0) {
            this.ticketForm.controls['relationName'].setValue(relationResponse['result'][0][0]['NAME'])
          }
        } else {
          this.LoaderComponent = "";
          this.noAccess = true;

        }
      })
    }

  }
  getCommunicationLog(type) {
    if (type === 1) {
      return {
        CallDiscussion: this.ticketForm.value['callDiscussion'],
        CallResult: this.ticketForm.value['callResult'],
        CallType: this.selectedRadioBtn === 2 ? "563:2" : "378:2",
        DisplayStatus: false,
        EmpID: this.loginData['employeeID'],
        PhoneNum: this.ticketForm['telNo'],
        RelationID: this.ticketForm.value['callRecv'][0]['value'],
        RelationName: this.ticketForm.value['relationName'],
        TicketID: this.data['ticketId'],
        VoiceCallType: this.ticketForm.value['voiceCallType'][0]['value'],
        intExpressIntID: this.responseHistory['ExpressInterestID'],
        intPendingEmpID: 0,
        intFromTicketStatus: 0,
      }
    } else {
      return {
        CallDiscussion: this.ticketForm.value['notes'],
        CallResult: this.ticketForm.value['callResult'],
        CallType: "378:1",
        DisplayStatus: false,
        EmpID: this.loginData['employeeID'],
        PhoneNum: this.ticketForm['telNo'],
        RelationID: this.ticketForm.value['callRecv'][0]['value'],
        RelationName: this.ticketForm.value['relationName'],
        TicketID: this.data['ticketId'],
        VoiceCallType: this.ticketForm.value['voiceCallType'][0]['value'],
        intExpressIntID: this.responseHistory['ExpressInterestID'],
        intPendingEmpID: 0,
        intFromTicketStatus: 0,
        ReasonID: this.ticketForm.value['reason'] ? this.ticketForm.value['reason'][0]['id'] : null
      }
    }

  }


  getCommunicationLogOut(type) {
    if (type === 1) {
      return {
        CallDiscussion: this.ticketForm.value['callDiscussion'],
        CallResult: this.ticketForm.value['callResult'],
        CallType: this.selectedRadioBtn === 2 ? "563:2" : "377:2",
        DisplayStatus: false,
        EmpID: this.loginData['employeeID'],
        PhoneNum: this.ticketForm['telNo'],
        RelationID: this.ticketForm.value['callRecv'][0]['value'],
        RelationName: this.ticketForm.value['relationName'],
        TicketID: this.data['ticketId'],
        VoiceCallType: this.ticketForm.value['voiceCallType'][0]['value'],
        intExpressIntID: this.responseHistory['ExpressInterestID'],
        intPendingEmpID: 0,
        intFromTicketStatus: 0,
        
      }
    } else {
      return {
        CallDiscussion: this.ticketForm.value['notes'],
        CallResult: this.ticketForm.value['callResult'],
        CallType: "377:1",
        DisplayStatus: false,
        EmpID: this.loginData['employeeID'],
        PhoneNum: this.ticketForm['telNo'],
        RelationID: this.ticketForm.value['callRecv'][0]['value'],
        RelationName: this.ticketForm.value['relationName'],
        TicketID: this.data['ticketId'],
        VoiceCallType: this.ticketForm.value['voiceCallType'][0]['value'],
        intExpressIntID: this.responseHistory['ExpressInterestID'],
        intPendingEmpID: 0,
        intFromTicketStatus: 0,
        ReasonID: this.ticketForm.value['reason'] ? this.ticketForm.value['reason'][0]['id'] : null
      }
    }
  }
  checckValue = () => {
    const formValue = this.ticketForm.value
    if ((formValue.rType == "2" && this.isOtherSideSecession) || (this.isOtherSideSecession)) {
      return "V";
    } else {
      return "I"
    }
  }

  getIntrestedNotIntrestedObject() {
    return {
      AcceptStatus: this.ticketForm.value.rType,
      CustID: this.data['custId'],
      ExpressInrestID: this.data['expressInterestId'],
      MatchFollwupStatus: this.ticketForm.value.rType == "2" && this.isOtherSideSecession ? 2 : 1,
      intEmpId: this.loginData['employeeID'],
      strFromStatus: this.checckValue()

    }
  }

  submitOutgoing() {
    if (!this.ticketForm.valid) {
      this.isTicketSubmitted = true
    }
  }
}